define( [
	"../Data"
], function( Data ) {
	"use strict";

	return new Data();
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/data/var/dataUser.js
// module id = 358
// module chunks = 1